import LockSVG from '../../icons/LockSVG'
import { usePeerAnalyserStore } from '../../state-management/peerAnalyserStore'
import { PerformanceLabel } from '../../types/mutual-fund-detail.types'

export type ScoreStatus = 'IN_FORM' | 'ON_TRACK' | 'OFF_TRACK' | 'OUT_OF_FORM' | 'PERFORMANCE_LOCKED' | 'NOT_RATED'

interface ReturnsProps {
  value: number | string | undefined
  status: ScoreStatus
  rank?: number
  className?: string
  showRank: boolean
  powerPerformance?: string
  performanceLabel?: PerformanceLabel
}

const statusStyles: Record<PerformanceLabel, { bg: string; text: string; svgColor: string }> = {
  GREAT: {
    bg: 'bg-status-in-form',
    text: 'text-status-text-in-form',
    svgColor: '#7ECA94'
  },
  GOOD: {
    bg: 'bg-status-on-track',
    text: 'text-status-text-on-track',
    svgColor: '#90DCA6'
  },
  AVERAGE: {
    bg: 'bg-status-off-track',
    text: 'text-status-text-off-track',
    svgColor: '#F0AAA0'
  },
  BAD: {
    bg: 'bg-status-out-of-form',
    text: 'text-status-text-out-of-form',
    svgColor: '#F0AAA0'
  },
  UNKNOWN: {
    bg: 'bg-[#F6F9F9]',
    text: 'text-black',
    svgColor: '#6A6E6E'
  }
}

export default function Returns({ value, status, rank, className = '', showRank, performanceLabel }: ReturnsProps) {
  const isSubscribedToPeerAnalyser = usePeerAnalyserStore((state) => state.isSubscribedToPeerAnalyser)
  const isUserElite = usePeerAnalyserStore((state) => state.isUserElite)
  const { text, bg } = statusStyles[performanceLabel as PerformanceLabel] || {
    bg: 'bg-[#F6F9F9]',
    text: 'text-black'
  }
  const hasValue = value !== undefined && value !== null && value !== ''
  const roundedOffValue = hasValue ? Number(Number(value).toFixed(1)) : null
  const hasDisplayValue = roundedOffValue !== null && !Number.isNaN(roundedOffValue)
  return (
    <>
      <div className='flex flex-row'>
        <div
          className={`w-[50px] h-16 ${bg} ${className} relative rounded-sm flex-shrink-0`}
          aria-label={`Score: ${value}, Status: ${status}`}
        >
          <div className='inline-flex items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
            <span
              className={`text-xs ${hasDisplayValue ? text : 'text-grey40'} relative bottom-0 font-medium transition-all duration-300 ease-in-out ${showRank ? '-translate-y-2' : ''}`}
            >
              {hasDisplayValue ? `${roundedOffValue.toFixed(1)}%` : '-'}
            </span>
            {/* unlockFundBottomSheets call disabled to avoid triggering bottom sheet */}
            <span
              className={`text-[11px] font-medium ${text} absolute top-[20%] left-1/2 -translate-x-1/2 transition-all duration-300 ease-in-out transform ${showRank ? 'translate-y-2 opacity-50 scale-100' : 'translate-y-0 opacity-0 scale-75'
                }`}
            >
              {status === 'PERFORMANCE_LOCKED' ? (
                <LockSVG color={'#D1D6D6'} />
              ) : status === 'NOT_RATED' ? (
                '-'
              ) : !isUserElite && !isSubscribedToPeerAnalyser ? (
                <LockSVG color={'#D1D6D6'} />
              ) : (
                rank || '-'
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  )
}
